import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=92c0675e&scoped=true"
import script from "@/views/Suppliers/Supplier.ts?vue&type=script&lang=ts&external"
export * from "@/views/Suppliers/Supplier.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/user.scss?vue&type=style&index=0&id=92c0675e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c0675e",
  null
  
)

export default component.exports